module.exports = __webpack_public_path__ + "assets/img/no-camera.cb2a22bf.jpg";